const initialState = {
    steps: [],
    utmSource: null,
    utmCampaign: null,
};

const calcolatoreReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_STEP':
            return {
                ...state,
                steps: [
                    ...state.steps,
                    action.step
                ]
            }
        case 'REMOVE_STEP':
            return {
                ...state,
                steps: state.steps.filter((item, index) => index !== action.step)
            }
        case 'RESET_STEPS':
            return initialState;
        case 'UTM_SOURCE':
            return {
                ...state,
                utmSource: action.utmSource
            }
        case 'UTM_CAMPAIGN':
            return {
                ...state,
                utmCampaign: action.utmCampaign
            }
        default:
            return state;
    }
}

export default calcolatoreReducer;